/**
 * Created by piotr.pozniak@thebeaverhead.com on 13/04/2023
 */

import React, { useCallback, useContext, useMemo } from "react";
import Dropdown from "./Dropdown";
import { AvailableRulesOptionsContext, FiltersContext } from "./contexts";

/**
 *
 * @param {Object} rule
 * @param {Number} id
 * @param {Number} groupId
 * @param {function} onClose
 * @param {string} submitLabel
 * @returns {React.JSX.Element}
 * @constructor
 */
const RuleEditDropdown = ({
  rule,
  id,
  groupId,
  onClose,
  submitLabel = "Done",
}) => {
  const availableRulesOptions = useContext(AvailableRulesOptionsContext);
  const { filters, updateGroup } = useContext(FiltersContext);

  const currentRuleSettings = availableRulesOptions.find(
    (r) => r.field.value === rule.field.value
  );

  const currentOperator = useMemo(
    () =>
      currentRuleSettings.operators.find(
        (operator) => operator.value === rule.operator.value
      ),
    [rule]
  );
  const { value, label } = filters.groups[groupId].rules[id];
  const onSelectOperator = useCallback(
    (operator) => (e) => {
      const updatedRule = {
        ...rule,
        value,
        label,
        operator: {
          value: operator.value,
          label: operator.label,
        },
      };

      const group = { ...filters.groups[groupId] };
      group.rules[id] = updatedRule;

      updateGroup(groupId, group);
    },
    [rule]
  );

  const input = (
    <div className={"filters__edit-rule__option-input"}>
      <currentOperator.input.component
        {...currentOperator.input.props}
        groupId={groupId}
        filterId={id}
      />
    </div>
  );

  const operators = useMemo(
    () =>
      currentRuleSettings.operators.map((setting) => {
        const checked = setting.value === rule.operator.value;
        const optionInput = checked ? input : null;

        return (
          <div
            key={`${setting.value}`}
            className={"filters__dropdown__option filters__edit-rule__option"}
          >
            <label>
              <input
                type={"radio"}
                name={"operator"}
                value={setting.value}
                checked={checked}
                onChange={onSelectOperator(setting)}
              />
              {setting.label}
            </label>
            {optionInput}
          </div>
        );
      }),
    [rule]
  );

  return (
    <Dropdown onClose={onClose}>
      {operators}
      <div className={"filters__edit-rule__submit"} onClick={onClose}>
        {submitLabel}
      </div>
    </Dropdown>
  );
};

export default RuleEditDropdown;
